import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataDate,
  ODataDateTime
} from "pbas-vue-components";

import { translate } from '../trans'
import store from '@/store'
import { i18n } from "@/plugins/i18n";
const ODataDependantsHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    title: "IdentityId",
    type: new ODataString("IdentityId"),
    sortable: true,
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  // new ODataHeader({
  //   title: "HasHistory",
  //   type: new ODataString("Identity/HasHistory"),
  //   sortable: true,
  //   visible: false,
  //   searchable: false,
  //   allowVisibilityChange: false
  // }),
  // new ODataHeader({
  //   title: "components.memberview.eligible",
  //   type: new ODataBoolean("Identity/IsEligible"),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  //   allowVisibilityChange: true
  // }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.effective_date",
  //   type: new ODataDate("EffectiveDate"),
  //   sortable: true,
  //   visible: true,
  //   searchable: true
  // }),
  
  // new ODataHeader({
  //   title: "headers.members_management.SIN",
  //   type: new ODataString("SIN"),
  //   sortable: true,
  // }),
  // new ODataHeader({
  //   type: new ODataString("Title/Name"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   type: new ODataString("Title/Translations[]/LanguageCode"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "headers.members_management.Title",
  //   type: new ODataString("Title/Translations[]/DisplayValue", {
  //     getString: item => {
  //       if (!item) return "";
  //       const lang = store.getters['common/language']
  //       return translate(item.Title, lang.language);
  //     }
  //   }),
  //   sortable: true,
  //   orderByKey: "Title/Name",
  // }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("FirstName"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  // new ODataHeader({
  //   title: "globals.middlename",
  //   type: new ODataString("MiddleName"),
  //   sortable: true,
  //   visible: true,
  //   searchable: true
  // }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("LastName"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  // new ODataHeader({
  //   type: new ODataString("Suffix/Name"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   type: new ODataString("Suffix/Translations[]/LanguageCode"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "headers.members_management.Suffix",
  //   type: new ODataString("Suffix/Translations[]/DisplayValue", {
  //     getString: item => {
  //       if (!item) return "";
  //       const lang = store.getters['common/language']
  //       return translate(item.Suffix, lang.language);
  //     }
  //   }),
  //   sortable: true,
  //   orderByKey: "Suffix/Name",
  // }),
  // new ODataHeader({
  //   title: "globals.gender",
  //   type: new ODataString("Gender/Name"),
  //   sortable: true,
  //   visible: false,
  //   searchable: true,
  //   allowVisibilityChange: false,
  //   version: 1
  // }),
  // new ODataHeader({
  //   type: new ODataString("Gender/Translations[]/LanguageCode"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "globals.gender",
  //   type: new ODataString("Gender/Translations[]/DisplayValue", {
  //     getString: item => {
  //       if (!item) return "";
  //       const lang = store.getters['common/language']
  //       return translate(item.Gender, lang.language);
  //     }
  //   }),
  //   visible: true,
  //   searchable: true,
  //   sortable: true,
  //   orderByKey: "Gender/Name",
  //   version: 1
  // }),
  // new ODataHeader({
  //   title: "Gender Id",
  //   type: new ODataString("Gender/Id"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "GenderId",
  //   type: new ODataString("GenderId"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  new ODataHeader({
    title: "globals.dob",
    type: new ODataDate("DateOfBirth"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "components.inmemorydependants.relationship",
    type: new ODataString("Relationship/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1
  }),
  new ODataHeader({
    type: new ODataString("Relationship/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "components.inmemorydependants.relationship",
    type: new ODataString("Relationship/Translations[]/DisplayValue", {
      getString: item => {
        if (!item) return "";
        const lang = store.getters['common/language']
        return translate(item.Relationship, lang.language);
      }
    }),
    visible: true,
    searchable: true,
    sortable: true,
    orderByKey: "Relationship/Name",
    version: 1
  }),
  
  new ODataHeader({
    title: "Relationship Id",
    type: new ODataString("Relationship/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "RelationshipId",
    type: new ODataString("RelationshipId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.dod",
  //   type: new ODataDate("DateOfDeath"),
  //   sortable: true,
  //   visible: true,
  //   searchable: true
  // }),
  new ODataHeader({
    title: "globals.inactive",
    type: new ODataBoolean("IsRemoved"),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1
  }),
  new ODataHeader({
    title: "components.inmemorydependants.disabled",
    type: new ODataBoolean("Disabled"),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1
  }),
  new ODataHeader({
    title: "components.inmemorydependants.student",
    type: new ODataBoolean("Student"),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1
  }),
  new ODataHeader({
    title: "components.inmemorydependants.school_completion_date",
    type: new ODataBoolean("Identity/Qualification/SchoolCompletionDate"),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1
  }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.overage",
  //   type: new ODataBoolean("Overage"),
  //   sortable: false,
  //   visible: false,
  //   searchable: false
  // }),
  // new ODataHeader({
  //   title: "headers.pension_regulators.activity",
  //   type: new ODataString("Activity", {
  //     getString: (item) => i18n.t("enums." + item.Activity),
  //   }),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  // }),
  // new ODataHeader({
  //   type: new ODataDateTime("UserType"),
  //   sortable: true,
  //   visible: false,
  //   searchable: true,
  //   allowVisibilityChange: false
  // }),
  // new ODataHeader({
  //   title: "globals.trigger",
  //   type: new ODataDateTime("User", {
  //     getString: (item) => {
  //       return `${item.UserType} (${item.User})`
  //     }
  //   }),
  //   sortable: true,
  //   searchable: true,
  //   visible: true,
  // }),
  // new ODataHeader({
  //   type: new ODataString("SourceOfInformation/Name"),
  //   sortable: false,
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   type: new ODataString("SourceOfInformation/Translations[]/LanguageCode"),
  //   sortable: false,
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "globals.source_of_information",
  //   type: new ODataString("SourceOfInformation/Translations[]/DisplayValue", {
  //     getString: (item) => translate(item.SourceOfInformation, store.getters['common/language'].language),
  //   }),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  //   orderByKey: "SourceOfInformation/Name",
  //   allowVisibilityChange: true,
  // }),
  // new ODataHeader({
  //   title: "globals.timestamp",
  //   type: new ODataDateTime("Timestamp"),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  //   allowVisibilityChange: true,
  //   version: 2
  // }),
];
export default ODataDependantsHeaders;